module.exports = "<div class=\"search-modal-body\">\n  <div class=\"clearfix visible-xs\">\n    <a class=\"pull-left close\" href=\"#\" ng-click=\"cancel()\">\n      <i class=\"fa fa-times\"></i>\n    </a>\n  </div>\n  <div class=\"content\">\n    <search modal=\"true\" callback=\"cancel\"></search>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/services/modal/search/searchModal.html
// module id = 884
// module chunks = 1